<template>
  <section class="section--support">
    <b-container class="container">
      <b-row class="row">
        <b-col  cols="12" lg="10" xl="8" offset-xl="2" offset-lg="1" class="text-center">
          <div class="support">
            <span class="support__content"> {{ $t("help")}} </span>
            <b-btn v-b-modal.helpModal class="btn btn-secondary btn-sm mt-3">
              {{ $t("ask")}}
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="container">
      <help-modal :askForHelp="askForHelp"></help-modal>
    </b-container>
  </section>
</template>

<script>
import HelpModal from '@/components/Support/HelpModal';

export default {
  components: {
    'help-modal': HelpModal,
  },
  data() {
    return {
      askForHelp: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';

.section--support {
  background-color: $color--orange;
  padding: 240px 0 90px;
  @include media('<lg') {
    padding: 130px 0 50px;
  }
}
.support {
  text-align: center;
  padding: 0 40px;
  @include media('<md') {
    padding: 0 40px;
  }
  @include media('<sm') {
    padding: 0;
  }
  &__content {
    font-size: 20px;
    font-family: Montserrat;
    color: $color--white;
    position: relative;
    text-align: center;
    letter-spacing: -0.3px;
    @include media('<lg') {
      font-size: 14px;
    }
    &:before {
      content: '?';
      position: absolute;
      bottom: 10px;
      left: 43%;
      font-size: 150px;
      @include media('<lg') {
        font-size: 80px;
      }
      @include media('<md') {
        bottom: 30px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Support/Index.vue